import React, { useEffect, useState } from "react";
import Circlebtn from "../components/Circlebtn";
import { CirclesThreeIcon, PlusIcon } from "../assets/icons/Icons";
import ScheduledPostCard from "../components/ScheduledPostCard";
import { CardSkeletonLoader } from "../components/CardSkeletonLoader";

const ScheduledPost = () => {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setTimeout(() => setLoading(false), 1000);
  }, []);
  return (
    <>
      <div className="flex items-center justify-between">
        <h1 className="text-[#0F0C18] text-[28px] font-medium leading-9 tracking-tight">Scheduled Posts</h1>
        <div className="flex items-center gap-2">
          <Circlebtn icon={<PlusIcon />} className="w-8 h-8 bg-white" />
          <Circlebtn icon={<CirclesThreeIcon />} className="w-8 h-8 bg-white" />
        </div>
      </div>
      <p className="text-[#9392A2] mt-4 text-xs font-medium tracking-tight">Statistics</p>
      <div className="mt-3 flex items-center gap-2 flex-wrap">
        <div className="w-[282px] h-[92px] bg-white p-4 rounded-xl">
          <h1 className="text-[#0F0C18] text-[28px] font-medium tracking-tight mb-1">76</h1>
          <p className="text-[#9392A2] text-xs font-medium tracking-tight">Posts scheduled</p>
        </div>
        <div className="w-[282px] h-[92px] bg-white p-4 rounded-xl">
          <h1 className="text-[#0F0C18] text-[28px] font-medium tracking-tight mb-1">1,322</h1>
          <p className="text-[#9392A2] text-xs font-medium tracking-tight">Posts published</p>
        </div>
      </div>
      <p className="text-[#9392A2] mt-10 mb-3 text-xs font-medium tracking-tight">5 account groups</p>
      <div className="mt-3 flex items-center gap-2 flex-wrap">
        {
          loading ?
          [...Array(6)].map((_, index) => <CardSkeletonLoader key={index} />) :
          [...Array(6)].map((_, index) => <ScheduledPostCard key={index} />)
        }
      </div>
    </>
  );
};

export default ScheduledPost;